export default "__VITE_ASSET__05362f10__"